import angular from 'angular';
import moment from 'moment';
import XLSX from 'xlsx';
import {
    IMudancaTrabalhadorItem,
    IAfastamentosListagem,
    IFolgasListagem,
    IEvento,
    IEventoExclusao,
    IEventoEnvio,
    IFeriadosListagem
} from '../models/escala.model';
import { ITrabalhadorSemPaginacao } from '../../../Trabalhadores/models/trabalhador.model';
import { ITrabalhadorCalendario } from '../models/escala.trabalhador.model';
import { IConfiguracaoScheduler, ITrabalhadorListagemScheduler } from '../models/escala.scheduler.model';
import { IConfiguracoesEscala, getConfiguracoesEscalaPadrao } from '../models/escala.configuracoes.model';
import { IErroImportacao } from '../models/escala.erros.model';
import { IFolga } from '../../../Folgas/models/folgas.model';
import { ILotacao } from '../../../Lotacao/models/lotacao.model';
import { IHorario } from '../../Solicitacoesadmissoes/models/horario.model';
import { IEstabelecimento } from '../../../Estabelecimentos/models/estabelecimento.model';
import { MeurhMudancasTrabalhadoresService } from '../../../MudancasTrabalhadores/mudancas-trabalhadores.service';
import { MeurhEscalaErrosImportacaoModalService } from '../importacao/modals/erros/erros.modal.service';
import { TrabalhadoresService } from '../../../Trabalhadores/trabalhadores.service';
import { FolgasService } from '../../../Folgas/folgas.service';
import { LotacoesService } from '../../../Lotacao/lotacao.service';
import { HorariosService } from '../../../Horarios/horarios.service';
import { MeurhAfastamentosService } from '../../Afastamentos/afastamentos.service';
import { ApuracoesPontoService } from '../../Ponto/ApuracoesPonto/apuracoesponto.service';
import { EmpresasService } from '../../../Empresas/empresas.service';
import { EstabelecimentosService } from '../../../Estabelecimentos/estabelecimentos.service';
import { MeurhEscalaSchedulerService } from '../escala.scheduler.service';
import { MeurhEscalaSchedulerColaboradoresService } from '../escala.scheduler.colaboradores.service';
import { TipoImportacaoEnum, ColunasArquivoImportacao } from '../enums/importacao';
import { MudancasTrabalhadoresTipoEnum } from '../../../MudancasTrabalhadores/enums/mudancas-trabalhadores.enum';
import { Scheduler, SchedulerStatic } from '../../../../shared/components/dhtmlx-scheduler/dhtmlxscheduler';
import { datasLimites } from '../consts/dataslimites';
import { ConfiguracoesService } from '../../../Configuracoes/configuracoes.service';
import {
    carregarConfiguracoesEscala,
    formatarDataFechamentoCalendario
} from '../helpers/configuracoes-escala';

export class MeurhEscalaController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'NewToaster',
        'MeurhMudancasTrabalhadoresService',
        'MeurhEscalaErrosImportacaoModalService',
        'TrabalhadoresService',
        'FolgasService',
        'LotacoesService',
        'HorariosService',
        'MeurhAfastamentosService',
        'ApuracoesPontoService',
        'EmpresasService',
        'EstabelecimentosService',
        'ConfiguracoesService',
        'MeurhEscalaSchedulerService',
        'MeurhEscalaSchedulerColaboradoresService',
    ];

    public busy: boolean = false;
    public filaExclusao: number = 0;
    public colaboradores: ITrabalhadorCalendario[] = []; // listagem dos colaboradores do sistema
    public lotacoes: ILotacao[] = []; // listagem das lotacoes do sistema
    public horarios: IHorario[] = []; // listagem dos horarios do sistema
    public empresas: any[] = []; // listagem dos empresas do sistema
    public estabelecimentos: IEstabelecimento[] = []; // listagem dos estabelecimentos do sistema
    public listaDeEventos: IEvento[] = []; // lista dos eventos no calendario
    public listaDeEventosBkp: IEvento[] = []; // backup da lista dos eventos ja existentes no calendario
    public listaImportados: IEvento[] = [];
    public estaImportando: boolean = false;
    public schedulerEventos: SchedulerStatic; // instancia do calendario
    public erroImportacao: IErroImportacao;
    public datasLimites = datasLimites;
    public configuracoesEscala: IConfiguracoesEscala = getConfiguracoesEscalaPadrao();
    public dataFechamentoCalendario = '';
    public busyLists = {
        configuracoes: true,
        trabalhadores: false,
        lotacoes: false,
        horarios: false,
        empresas: false,
        estabelecimentos: false,
    };
    public busyEvents = {
        eventosFolgas: false,
        eventosFolgasFixas: false,
        eventosAfastamentos: false,
        eventosFeriados: false,
        eventosLotacoes: false,
        eventosHorarios: false,
    };
    public filtrosVisibilidade: { empresa: string, estabelecimento: string };

    private colaboradoresMap: Map<string, ITrabalhadorListagemScheduler> | null = null;
    private eventoHandlers: Map<
        TipoImportacaoEnum,
        (entity: unknown, colab: ITrabalhadorCalendario, tipo: TipoImportacaoEnum) => void
    >;

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissao: (arg: string) => boolean,
            nsjGlobals: any,
            session: any
        },
		public $state: angular.ui.IStateService,
        public NewToaster: { pop: Function },
        public MeurhMudancasTrabalhadoresService: MeurhMudancasTrabalhadoresService,
        public ErrosImportacaoModalService: MeurhEscalaErrosImportacaoModalService,
        public TrabalhadoresService: TrabalhadoresService,
        public FolgasService: FolgasService,
        public LotacoesService: LotacoesService,
        public HorariosService: HorariosService,
        public MeurhAfastamentosService: MeurhAfastamentosService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public EmpresasService: EmpresasService,
        public EstabelecimentosService: EstabelecimentosService,
        public ConfiguracoesService: ConfiguracoesService,
        public MeurhEscalaSchedulerService: MeurhEscalaSchedulerService,
        public MeurhEscalaSchedulerColaboradoresService: MeurhEscalaSchedulerColaboradoresService,
	) {
        if (
            !this.$rootScope.temPermissao('visualizar_calendario') ||
            !this.$rootScope.liberadoTela('LIBERAR_CALENDARIO')
        ) {
            $state.go('dp');
        }

        this.filtrosVisibilidade = {
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento
        };

        this.carregaConfiguracoesEscala();
        this.carregaColaboradores({ status: '00', ...this.filtrosVisibilidade });
        this.onResponseSuccess();
        this.onResponseError();

        this.eventoHandlers = new Map([
            [TipoImportacaoEnum.FOLGA, this.handleFolgas.bind(this)],
            [TipoImportacaoEnum.FOLGAFIXA, this.handleFolgas.bind(this)],
            [TipoImportacaoEnum.AFASTAMENTO, this.handleAfastamento.bind(this)],
            [TipoImportacaoEnum.FERIADO, this.handleFeriado.bind(this)],
            [TipoImportacaoEnum.LOTACAO, this.handleMudancaTrabalhador.bind(this)],
            [TipoImportacaoEnum.HORARIO, this.handleMudancaTrabalhador.bind(this)],
        ]);

        this.$scope.$on('colaboradores_refresh', () => {
            this.statusImportacao(false, true);
            this.schedulerEventos.destructor();
            this.schedulerEventos = Scheduler.getSchedulerInstance();
            this.carregaColaboradores({ status: '00', ...this.filtrosVisibilidade });
        });

        // listagem de colaboradores do sistema
        this.$scope.$on('persona_trabalhadores_sempaginacao_loaded', (event, args: ITrabalhadorSemPaginacao[]) => {
            this.colaboradores = args.map(colaborador => ({...colaborador, eventos: {}}));
            this.colaboradoresMap = null;
            this.busyLists.trabalhadores = false;
            if (this.colaboradores.length) {
                this.carregaListagens();
            } else {
                this.busy = false;
            }
        });

        // listagem de lotacoes do sistema
        this.$scope.$on('lotacoes_list_finished', (event, args: any[]) => {
            this.lotacoes = args;
            this.busyLists.lotacoes = false;
        });

        // listagem de horarios do sistema
        this.$scope.$on('horarios_list_finished', (event, args: any[]) => {
            this.horarios = args;
            this.busyLists.horarios = false;
        });

        // listagem de empresas do sistema
        this.$scope.$on('empresas_list_finished', (event, args: any[]) => {
            this.empresas = args;
            this.busyLists.empresas = false;
        });

        // listagem de estabelecimentos do sistema
        this.$scope.$on('estabelecimentos_list_finished', (event, args: any[]) => {
            this.estabelecimentos = args;
            this.busyLists.estabelecimentos = false;
        });

        // eventos de folgas existentes
        this.$scope.$on('folgas_sempaginacao_loaded', (event, args: IFolgasListagem[]) => {
            const folgasLista = Object.values(args);
            this.montaEventosCalendario(folgasLista, TipoImportacaoEnum.FOLGA);
            this.busyEvents.eventosFolgas = false;
        });

        // eventos de folgas fixas existentes
        this.$scope.$on('folgas_fixas_loaded', (event, args: IFolgasListagem[]) => {
            const folgasFixasLista = Object.values(args);
            this.montaEventosCalendario(folgasFixasLista, TipoImportacaoEnum.FOLGAFIXA);
            this.busyEvents.eventosFolgasFixas = false;
        });

        // eventos de feriados existentes
        this.$scope.$on('persona_trabalhadores_feriados_loaded', (event, args: IFeriadosListagem[]) => {
            const feriadosLista = Object.values(args);
            this.montaEventosCalendario(feriadosLista, TipoImportacaoEnum.FERIADO);
            this.busyEvents.eventosFeriados = false;
        });

        // eventos de afastamentos existentes
        this.$scope.$on('meurh_solicitacoesafastamentos_sempaginacao_loaded', (event, args: IAfastamentosListagem[]) => {
            const afastamentosLista = Object.values(args);
            this.montaEventosCalendario(afastamentosLista, TipoImportacaoEnum.AFASTAMENTO);
            this.busyEvents.eventosAfastamentos = false;
        });

        // eventos de lotacao/horarios existentes
        this.$scope.$on('mudancastrabalhadores_sempaginacao_loaded', (event, args: IMudancaTrabalhadorItem[], tipo: number) => {
            if (tipo === MudancasTrabalhadoresTipoEnum.LOTACAO) {
                this.montaEventosCalendario(args, TipoImportacaoEnum.LOTACAO);
                this.busyEvents.eventosLotacoes = false;
            } else if (tipo === MudancasTrabalhadoresTipoEnum.HORARIO) {
                this.montaEventosCalendario(args, TipoImportacaoEnum.HORARIO);
                this.busyEvents.eventosHorarios = false;
            }
        });

        this.$scope.$on('calendario_salva_evento', (event, args: IEvento) => {
            this.salvar({
                eventos: [this.montaObjetoRequisicao(args, 'salvar')],
                tipoEventos: args.evento
            });
        });

        this.$scope.$on('calendario_edita_evento', (event, args: IEvento) => {
            this.editar({
                evento: this.montaObjetoRequisicao(args, 'editar'),
                tipoEvento: args.evento
            });
        });

        this.$scope.$on('calendario_exclui_evento', (event, args: IEvento) => {
            this.excluir({
                [args.evento]: [this.montaObjetoRequisicao(args, 'excluir')]
            });
        });

        this.$scope.$on('calendario_carregaEventos', (event, args: Date) => {
            this.busy = true;
            this.carregaEventos(args);
        });

        // inicia o calendario quando todas as listagens estiverem prontas
        this.$scope.$watchGroup([
        'mrh_scl_cntrllr.busyLists.configuracoes',
        'mrh_scl_cntrllr.busyLists.trabalhadores',
        'mrh_scl_cntrllr.busyLists.lotacoes',
        'mrh_scl_cntrllr.busyLists.horarios',
        'mrh_scl_cntrllr.busyLists.empresas',
        'mrh_scl_cntrllr.busyLists.estabelecimentos'], (newValues: boolean[], oldValues: boolean[]) => {
			if (newValues !== oldValues && (newValues.every((busy) => busy === false))) {
                let configCalendario: IConfiguracaoScheduler = {
                    colaboradores: this.colaboradores,
                    lotacoes: this.lotacoes,
                    horarios: this.horarios,
                    dataInicial: this.datasLimites.dataInicial,
                    dataFinal: this.datasLimites.dataFinal,
                    usaSlaCalendario: this.configuracoesEscala.USA_SLA_CALENDARIO,
                    fechamentoCalendario: this.configuracoesEscala.FECHAMENTO_CALENDARIO,
                    calendarioFechaProximoMes: this.configuracoesEscala.CALENDARIO_FECHA_PROXIMO_MES
                };
                this.MeurhEscalaSchedulerService.configuraCalendario(this.schedulerEventos, configCalendario);
                this.schedulerEventos.init('schedulerEventos', new Date(), 'mes_timeline');
                this.carregaEventos(new Date());
			}
		});

        this.$scope.$watchGroup(['mrh_scl_cntrllr.busyEvents.eventosFolgas',
        'mrh_scl_cntrllr.busyEvents.eventosFolgasFixas',
        'mrh_scl_cntrllr.busyEvents.eventosLotacoes',
        'mrh_scl_cntrllr.busyEvents.eventosHorarios',
        'mrh_scl_cntrllr.busyEvents.eventosAfastamentos',
        'mrh_scl_cntrllr.busyEvents.eventosFeriados'], (newValues: boolean[], oldValues: boolean[]) => {
			if (newValues !== oldValues && (newValues.every((busy) => busy === false))) {
                if (this.estaImportando) {
                    this.listaImportados.map((ev, index) => {
                        ev.id = (this.listaDeEventos.length + 1) + index;
                    });
                    this.listaDeEventos = [...this.listaDeEventos, ...this.listaImportados];
                }
                this.renderizaEventos();
                this.busy = false;
			}
		});
    }

    $onInit() {
        this.schedulerEventos = Scheduler.getSchedulerInstance();
    }

    exibirPagina() {
        this.MeurhEscalaSchedulerService.atualizaListagem(this.schedulerEventos);
    }

    salvar(eventos?: IEventoEnvio) {
        let eventosEnviar: IEventoEnvio = eventos ? eventos : this.montaEnvio();
        this.busy = true;
        if (eventosEnviar.tipoEventos === TipoImportacaoEnum.FOLGA) {
            this.FolgasService.salvarEmLote(eventosEnviar.eventos as IFolga[]);
        } else if (eventosEnviar.tipoEventos === TipoImportacaoEnum.LOTACAO ||
            eventosEnviar.tipoEventos === TipoImportacaoEnum.HORARIO) {
            const tipo = eventosEnviar.tipoEventos === TipoImportacaoEnum.LOTACAO ? MudancasTrabalhadoresTipoEnum.LOTACAO : MudancasTrabalhadoresTipoEnum.HORARIO;
            this.MeurhMudancasTrabalhadoresService.salvarEmLote(eventosEnviar.eventos, tipo);
        }
    }

    editar(evento: {evento: any, tipoEvento: string}) {
        this.busy = true;
        if (evento.tipoEvento === TipoImportacaoEnum.LOTACAO ||
            evento.tipoEvento === TipoImportacaoEnum.HORARIO) {
            const tipo = evento.tipoEvento === TipoImportacaoEnum.LOTACAO ?
                MudancasTrabalhadoresTipoEnum.LOTACAO : MudancasTrabalhadoresTipoEnum.HORARIO;
            this.MeurhMudancasTrabalhadoresService.editar(evento.evento, tipo);
        }
    }

    excluir(eventos: Partial<IEventoExclusao>) {
        this.busy = true;
        if (eventos.folga && eventos.folga.length) {
            this.filaExclusao++;
            this.FolgasService.excluirEmLote(eventos.folga);
        }
        if (eventos.lotacao && eventos.lotacao.length) {
            this.filaExclusao++;
            this.MeurhMudancasTrabalhadoresService.excluirEmLote(eventos.lotacao, MudancasTrabalhadoresTipoEnum.LOTACAO);
        }
        if (eventos.horario && eventos.horario.length) {
            this.filaExclusao++;
            this.MeurhMudancasTrabalhadoresService.excluirEmLote(eventos.horario, MudancasTrabalhadoresTipoEnum.HORARIO);
        }
    }

    statusImportacao(status: boolean, atualizaEntities?: boolean) {
        if (atualizaEntities) {
            this.schedulerEventos.clearAll();
            angular.copy(this.listaDeEventosBkp, this.listaDeEventos);
            this.renderizaEventos();
            this.resetErrosImportacao();
        }
        this.estaImportando = status;
        this.MeurhEscalaSchedulerService.habilitaCriacaoIndividualCalendario(this.schedulerEventos, status);
    }

    abrirModalErros() {
        this.ErrosImportacaoModalService.open(this.erroImportacao.erros, this.erroImportacao.tipoImportacao).result.then(() => {/**/})
        .catch(() => {/**/});
    }

    downloadErros() {
        // constroi a planilha com as colunas de
        // identificador, data, solicitacao (se precisar de guid) e descricao do erro
        const data = this.erroImportacao.erros.map((event) => {
            return {
                identificador: event.importacao?.identificador,
                [ColunasArquivoImportacao[this.erroImportacao.tipoImportacao].data]: event.data,
                ...((this.erroImportacao.tipoImportacao !== TipoImportacaoEnum.FOLGA) && {
                    [ColunasArquivoImportacao[this.erroImportacao.tipoImportacao].dataFinal]: event.dataFim,
                    [this.erroImportacao.tipoImportacao]: event.importacao?.[this.erroImportacao.tipoImportacao],
                    empresa: event.importacao?.empresa,
                }),
                ...((this.erroImportacao.tipoImportacao === TipoImportacaoEnum.FOLGA && event.importacao?.estabelecimento) && {
                    estabelecimento: event.importacao?.estabelecimento,
                }),
                ...((this.erroImportacao.tipoImportacao === TipoImportacaoEnum.FOLGA && event.importacao?.descricao) && {
                    descricao: event.importacao?.descricao,
                }),
                descricao_erro: event.descricao
            };
        });

        this.exportToExcel(data, 'Erros', 'escala_erros_importacao.xlsx');
    }

    msgCardAvisoErros() {
        let palavras = ['Dos', 'o(s)', 'importado(s)', 'evento(s)'];
        if (this.erroImportacao.tipoImportacao === TipoImportacaoEnum.FOLGA) {
            palavras = ['Das', 'a(s)', 'importada(s)', 'folga(s)'];
        } else if (this.erroImportacao.tipoImportacao === TipoImportacaoEnum.LOTACAO) {
            palavras = ['Das', 'a(s)', 'importada(s)', 'lotação(ões)'];
        } else if (this.erroImportacao.tipoImportacao === TipoImportacaoEnum.HORARIO) {
            palavras = ['Dos', 'o(s)', 'importado(s)', 'horário(s)'];
        }
        return `${palavras[0]} ${this.erroImportacao.total} ${palavras[3]} no arquivo, há ${this.erroImportacao.erros.length} erro(s)! Você pode iniciar uma nova importação após ajustá-lo(s), ou, ignorá-lo(s) e salvar apenas ${palavras[1]} ${palavras[3]} ${palavras[2]}.`;
    }

    private exportToExcel(data: any[], sheetName: string, fileName: string) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const excelBlob = new Blob([wbout], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const downloadLink = document.createElement('a');
        downloadLink.setAttribute('download', fileName);
        downloadLink.setAttribute('href', window.URL.createObjectURL(excelBlob));
        downloadLink.click();
    }

    private resetErrosImportacao() {
        this.erroImportacao = {
            tipoImportacao: '',
            origemErro: '',
            erros: [],
            validos: undefined,
            total: undefined
        };
    }

    private carregaConfiguracoesEscala() {
        this.busyLists.configuracoes = true;

        carregarConfiguracoesEscala(this.ConfiguracoesService)
            .then((configuracoesEscala) => {
                this.configuracoesEscala = configuracoesEscala;
                this.dataFechamentoCalendario = formatarDataFechamentoCalendario(configuracoesEscala);
            })
            .finally(() => {
                this.busyLists.configuracoes = false;
                this.$scope.$applyAsync();
            });
    }

    private carregaColaboradores(filter?: {status: string, empresa: string, estabelecimento: string}) {
        this.busy = this.busyLists.trabalhadores = true;
        this.MeurhEscalaSchedulerService.reload();
        this.TrabalhadoresService.loadNoPagination(filter);
    }

    private carregaListagens() {
        this.LotacoesService.constructors.empresa = this.HorariosService.constructors.empresa = this.filtrosVisibilidade.empresa;
        this.LotacoesService.constructors.estabelecimento = this.HorariosService.constructors.estabelecimento = this.filtrosVisibilidade.estabelecimento;
        this.LotacoesService.reload(false);
        this.HorariosService.reload(false);
        this.EstabelecimentosService.reload();
        this.EmpresasService.reload();

        Object.keys(this.busyLists).forEach((i) => {
            if (i !== 'trabalhadores' && i !== 'configuracoes') {
                this.busyLists[i] = true;
            }
        });
    }

    private carregaEventos(dataAtual: Date) {
        this.resetEventosColaboradores();
        this.listaImportados = this.estaImportando ? this.listaDeEventos.filter(ev => ev.importacao) : [];
        this.schedulerEventos.clearAll();
        this.listaDeEventos = [];

        const params = {
            empresa: this.filtrosVisibilidade.empresa,
            ...((this.filtrosVisibilidade.estabelecimento !== '') && {
                trabalhador_estabelecimento: this.filtrosVisibilidade.estabelecimento,
            }),
        };

        const dataMesAnterior = new Date(dataAtual.getFullYear(), dataAtual.getMonth() - 1, 20);
        const dataMesPosterior = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 10);
        let datainicio = moment(dataMesAnterior);
        let datafim = moment(dataMesPosterior);
        if (datafim.isAfter(moment(this.datasLimites.dataFinal))) {
            datafim = moment(this.datasLimites.dataFinal);
        }
        const intervaloDeDatas = {
            datainicio: datainicio.format('YYYY-MM-DD'),
            datafim: datafim.format('YYYY-MM-DD')
        };

        this.FolgasService.loadNoPagination({...intervaloDeDatas, ...params});
        this.FolgasService.getFolgasFixas({...intervaloDeDatas, ...params});
        this.MeurhAfastamentosService.loadNoPagination({...intervaloDeDatas, ...params});
        this.TrabalhadoresService.getFeriadosTrabalhadores({...intervaloDeDatas, ...params});
        this.MeurhMudancasTrabalhadoresService.listarSemPaginacao({
            datainicial: intervaloDeDatas.datainicio,
            tipo: MudancasTrabalhadoresTipoEnum.LOTACAO,
            excluida: 0,
            ...params
        });
        this.MeurhMudancasTrabalhadoresService.listarSemPaginacao({
            datainicial: intervaloDeDatas.datainicio,
            tipo: MudancasTrabalhadoresTipoEnum.HORARIO,
            excluida: 0,
            ...params
        });

        Object.keys(this.busyEvents).forEach((i) =>  this.busyEvents[i] = true);
    }

    private resetEventosColaboradores() {
        this.MeurhEscalaSchedulerColaboradoresService.colaboradores.forEach(colaborador => colaborador.colaboradorObj.eventos = {});
    }

    private onResponseSuccess() {
        this.$scope.$on('folgas_lote_submitted', (event, args) => this.responseSuccess(event, args, TipoImportacaoEnum.FOLGA, 'save'));
        this.$scope.$on('folgas_lote_deleted', (event, args) => {
            this.filaExclusao--;
            if (this.filaExclusao === 0) {
                this.responseSuccess(event, args, TipoImportacaoEnum.FOLGA, 'delete');
            }
        });
        this.$scope.$on('mudancastrabalhadores_lote_submitted', (event, args, tipo) =>  {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.responseSuccess(event, args, importacao, 'save');
        });
        this.$scope.$on('mudancastrabalhadores_lote_edited', (event, args, tipo) =>  {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.responseSuccess(event, args, importacao, 'save');
        });
        this.$scope.$on('mudancastrabalhadores_lote_deleted', (event, args, tipo) => {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.filaExclusao--;
            if (this.filaExclusao === 0) {
                this.responseSuccess(event, args, importacao, 'delete');
            }
        });
    }

    private responseSuccess(event: angular.IAngularEvent, args: any, eventType: string, requestType: string) {
        this.statusImportacao(false);
        let message = '';
        if (eventType === TipoImportacaoEnum.FOLGA) {
            message = (requestType === 'save') ? 'As folgas foram salvas com sucesso!' : 'As folgas foram excluídas com sucesso!';
            if (args.dataLength === 1) {
                message = (requestType === 'save') ? 'A folga foi salva com sucesso!' : 'A folga foi excluída com sucesso!';
            }
        } else if (eventType === TipoImportacaoEnum.LOTACAO) {
            message = (requestType === 'save') ? 'As lotações foram salvas com sucesso!' : 'As lotações foram excluídas com sucesso!';
            if (args.dataLength === 1) {
                message = (requestType === 'save') ? 'A lotação foi salva com sucesso!' : 'A lotação foi excluída com sucesso!';
            }
        } else if (eventType === TipoImportacaoEnum.HORARIO) {
            message = (requestType === 'save') ? 'Os horários foram salvos com sucesso!' : 'Os horários foram excluídos com sucesso!';
            if (args.dataLength === 1) {
                message = (requestType === 'save') ? 'O horário foi salvo com sucesso!' : 'O horário foi excluído com sucesso!';
            }
        }
        this.NewToaster.pop({
            type: 'success',
            title: message
        });
        this.resetErrosImportacao();
        this.carregaEventos(this.schedulerEventos.getState().date);
    }

    private onResponseError() {
        this.$scope.$on('folgas_lote_submit_error', (event, args) => this.responseError(event, args, TipoImportacaoEnum.FOLGA, 'save'));
        this.$scope.$on('folgas_lote_delete_error', (event, args) => this.responseError(event, args, TipoImportacaoEnum.FOLGA, 'delete'));
        this.$scope.$on('mudancastrabalhadores_lote_submit_error', (event, args, tipo) =>  {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.responseError(event, args, importacao, 'save');
        });
        this.$scope.$on('mudancastrabalhadores_lote_edit_error', (event, args, tipo) =>  {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.responseError(event, args, importacao, 'save');
        });
        this.$scope.$on('mudancastrabalhadores_lote_delete_error', (event, args, tipo) => {
            const importacao = tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? TipoImportacaoEnum.LOTACAO : TipoImportacaoEnum.HORARIO;
            this.responseError(event, args, importacao, 'delete');
        });
    }

    private responseError(event: angular.IAngularEvent, args: any, eventType: string, requestType: string) {
        this.statusImportacao(false);
        this.busy = false;
        if ((args.response && args.response.data) && typeof (args.response.data.message) !== 'undefined' && args.response.data.message) {
            if (args.response.data.message === 'Validation Failed') {
                let message = args.response.data.errors.errors[0];
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro de validação',
                    body: message,
                    bodyOutputType: 'trustedHtml'
                });
            } else {
                this.NewToaster.pop({
                    type: 'error',
                    title: args.response.data.message
                });
            }
        } else {
            let message = '';
            if (eventType === TipoImportacaoEnum.FOLGA) {
                message = (requestType === 'save') ? 'Ocorreu um erro ao salvar a(s) folga(s)!' : 'Ocorreu um erro ao excluir a(s) folga(s)!';
            } else if (eventType === TipoImportacaoEnum.LOTACAO) {
                message = (requestType === 'save') ? 'Ocorreu um erro ao salvar a(s) lotação(ões)!' : 'Ocorreu um erro ao excluir a(s) lotação(ões)!';
            } else if (eventType === TipoImportacaoEnum.HORARIO) {
                message = (requestType === 'save') ? 'Ocorreu um erro ao salvar o(s) horário(s)!' : 'Ocorreu um erro ao excluir o(s) horário(s)!';
            }
            this.NewToaster.pop({
                type: 'error',
                title: message
            });
        }
        this.$state.reload();
    }

    private montaEnvio() {
        let importados: IEventoEnvio = {
            eventos: [],
            tipoEventos: ''
        };
        let eventosCalendario: IEvento[] = this.schedulerEventos.getEvents();
        let indexFinal = eventosCalendario.length;
        for (let index = this.listaDeEventosBkp.length; index < indexFinal; index++) {
            importados.eventos.push(this.montaObjetoRequisicao(eventosCalendario[index], 'salvar'));
        }
        importados.tipoEventos = eventosCalendario[indexFinal - 1].evento;
        return importados;
    }

    private montaObjetoRequisicao(evento: IEvento, tipoRequisicao: string): any {
        if (evento.evento === TipoImportacaoEnum.FOLGA) {
            return {
                datafolga: moment(evento.start_date).format('YYYY-MM-DD'),
                descricao: evento.descricao,
                trabalhador: evento.colaborador.trabalhador,
                empresa: evento.empresa,
                estabelecimento: evento.estabelecimento,
                ...((tipoRequisicao === 'salvar' ? true : false) && {
                    justificativa: '',
                })
            };
        } else if (evento.evento === TipoImportacaoEnum.LOTACAO || evento.evento === TipoImportacaoEnum.HORARIO) {
            return {
                datainicial: moment(evento.start_date).format('YYYY-MM-DD'),
                datafinal: !evento.start_date_only ? moment(evento.end_date).format('YYYY-MM-DD') : null,
                tipo: evento.evento === TipoImportacaoEnum.LOTACAO ? MudancasTrabalhadoresTipoEnum.LOTACAO : MudancasTrabalhadoresTipoEnum.HORARIO,
                pk_entidade: evento.evento === TipoImportacaoEnum.LOTACAO ? evento.lotacao : evento.horario,
                trabalhador: evento.colaborador.trabalhador,
                empresa: evento.empresa,
                estabelecimento: evento.estabelecimento,
                ...((tipoRequisicao === 'excluir' ? true : false) && {
                    mudancatrabalhador: evento.mudancatrabalhador,
                }),
            };
        }
    }

    private renderizaEventos() {
        this.schedulerEventos.parse(this.listaDeEventos);
        this.$scope.$broadcast('update_filtro_listagem_escala');
    }

    private getColaboradoresMap() {
        if (this.colaboradoresMap) {
            return this.colaboradoresMap;
        }

        const mapa = new Map<string, ITrabalhadorListagemScheduler>();
        const colaboradores = this.MeurhEscalaSchedulerColaboradoresService.colaboradores;
        for (const colaborador of colaboradores) {
            mapa.set(colaborador.colaboradorObj.trabalhador, colaborador);
        }

        this.colaboradoresMap = mapa;

        return this.colaboradoresMap;
    }

    private getIdColaboradorDoEvento(
        evento: (IMudancaTrabalhadorItem | IFolgasListagem | IAfastamentosListagem | IFeriadosListagem),
        tipo: TipoImportacaoEnum
    ) {
        if (tipo === TipoImportacaoEnum.HORARIO || tipo === TipoImportacaoEnum.LOTACAO) {
            return (evento as IMudancaTrabalhadorItem).trabalhador.trabalhador;
        }

        if ('trabalhador' in evento) {
            return (evento as IFolgasListagem | IAfastamentosListagem | IFeriadosListagem).trabalhador;
        }

        return null;
    }

    private montaEventosCalendario(
        eventosLista: (IMudancaTrabalhadorItem | IFolgasListagem | IAfastamentosListagem | IFeriadosListagem)[],
        tipo: TipoImportacaoEnum
    ) {
        const colaboradoresMap = this.getColaboradoresMap();
        for (const evento of eventosLista) {
            const idColaborador = this.getIdColaboradorDoEvento(evento, tipo);
            if (idColaborador) {
                const colaborador = colaboradoresMap.get(idColaborador);
                if (colaborador) {
                    this.adicionaEventoCalendario(evento, colaborador.colaboradorObj, tipo);
                }
            }
        }
        angular.copy(this.listaDeEventos, this.listaDeEventosBkp);
    }

    private adicionaEventoCalendario(
        eventoEntity: unknown,
        colaborador: ITrabalhadorCalendario,
        tipo: TipoImportacaoEnum
    ) {
        const handler = this.eventoHandlers.get(tipo);
        if (handler) {
            handler(eventoEntity, colaborador, tipo);
        }
    }

    private handleFolgas(
        eventoEntity: IFolgasListagem,
        colaborador: ITrabalhadorCalendario,
        tipo: TipoImportacaoEnum
    ) {
        eventoEntity.folgas.forEach((data) => {
            const evento: Partial<IEvento> = {
                start_date: moment(data.datafolga).toDate(),
                end_date: moment(data.datafolga).toDate(),
                colaborador,
                evento: tipo,
                descricao: data.descricao
            };
            this.MeurhEscalaSchedulerService.adicionaEventoCalendario(this.schedulerEventos, evento, this.listaDeEventos);
        });
        colaborador.eventos.folgas = eventoEntity.folgas;
    }

    private handleAfastamento(
        eventoEntity: IAfastamentosListagem,
        colaborador: ITrabalhadorCalendario,
        tipo: TipoImportacaoEnum
    ) {
        eventoEntity.afastamentos.forEach((data) => {
            const evento: Partial<IEvento> = {
                start_date: moment(data.data).toDate(),
                end_date: moment(data.data).add(data.dias - 1, 'day').toDate(),
                colaborador,
                evento: tipo,
                afastamento: data.tipohistorico.descricao,
            };
            this.MeurhEscalaSchedulerService.adicionaEventoCalendario(this.schedulerEventos, evento, this.listaDeEventos);
        });
        colaborador.eventos.afastamentos = eventoEntity.afastamentos;
    }

    private handleFeriado(
        eventoEntity: IFeriadosListagem,
        colaborador: ITrabalhadorCalendario,
        tipo: TipoImportacaoEnum
    ) {
        eventoEntity.feriados.forEach((data) => {
            const evento: Partial<IEvento> = {
                start_date: moment(data.dataferiado).toDate(),
                end_date: moment(data.dataferiado).toDate(),
                colaborador,
                evento: tipo,
            };
            this.MeurhEscalaSchedulerService.adicionaEventoCalendario(this.schedulerEventos, evento, this.listaDeEventos);
        });
        colaborador.eventos.feriados = eventoEntity.feriados;
    }

    private handleMudancaTrabalhador(
        eventoEntity: IMudancaTrabalhadorItem,
        colaborador: ITrabalhadorCalendario,
        tipo: TipoImportacaoEnum
    ) {
        const semLotacao = tipo === TipoImportacaoEnum.LOTACAO && !eventoEntity.lotacao?.lotacao;
        const semHorario = tipo === TipoImportacaoEnum.HORARIO && !eventoEntity.horario?.horario;

        if (semLotacao || semHorario) {
            return;
        }

        const dataFim = eventoEntity.datafinal
            ? moment(eventoEntity.datafinal).toDate()
            : moment(this.datasLimites.dataFinal, 'DD/MM/YYYY').toDate();

        const evento: Partial<IEvento> = {
            start_date: moment(eventoEntity.datainicial).toDate(),
            end_date: dataFim,
            start_date_only: !eventoEntity.datafinal,
            colaborador,
            evento: tipo,
            lotacao: eventoEntity.lotacao?.lotacao,
            horario: eventoEntity.horario?.horario,
            mudancatrabalhador: eventoEntity.mudancatrabalhador,
            primeira_mudanca: eventoEntity.primeira_mudanca
        };
        this.MeurhEscalaSchedulerService.adicionaEventoCalendario(this.schedulerEventos, evento, this.listaDeEventos);

        if (tipo === TipoImportacaoEnum.LOTACAO) {
            colaborador.eventos.lotacoes = (colaborador.eventos.lotacoes ?? []);
            colaborador.eventos.lotacoes.push(eventoEntity);
        } else if (tipo === TipoImportacaoEnum.HORARIO) {
            colaborador.eventos.horarios = (colaborador.eventos.horarios ?? []);
            colaborador.eventos.horarios.push(eventoEntity);
        }
    }
}
